module.exports = __webpack_public_path__ + "img/sad-man.6b5252c4.png";